module.exports = __webpack_public_path__ + "static/media/SS19-HappySocks-Showroom-Background-1600x500.ebd51e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/img/SS19-HappySocks-Showroom-Background-1600x500.png
// module id = 459
// module chunks = 0